import { useEffect, useState } from "react"
import { arrayOf, shape, number, object } from "prop-types"
import { Button, StackView } from "@planningcenter/tapestry-react"
import AttendeeCheckbox from "./AttendeeCheckbox"
import useApiClient from "hooks/use_api_client"

const WaitlistedAttendees = ({ attendees, registration, event }) => {
  const [loading, setLoading] = useState(false)
  const [selectedAttendees, setSelectedAttendees] = useState({})
  const handleSelect = id => {
    return e => {
      setSelectedAttendees(currentSelections => ({
        ...currentSelections,
        [id]: e.target.checked
      }))
    }
  }

  // If attendees changes, update selectedAttendees to only include those that are still in the list
  useEffect(() => {
    setSelectedAttendees(currentSelections =>
      Object.fromEntries(
        Object.entries(currentSelections).filter(([id]) =>
          attendees.some(attendee => attendee.id === Number(id))
        )
      )
    )
  }, [attendees])

  const anyAttendeesChecked = () => Object.values(selectedAttendees).some(value => value)

  const api = useApiClient("registrations")
  const selectedAttendeeIds = Object.keys(selectedAttendees).filter(k => selectedAttendees[k])

  const handleWaitlistPromotion = () => {
    setLoading(true)
    return api
      .post({
        url: `/registrations/${registration.id}/promote_waitlist`,
        data: {
          attendee_ids: selectedAttendeeIds
        }
      })
      .then(_ => {
        return Turbolinks.visit()
      })
  }

  return (
    <>
      <div className="d-f ai-c jc-sb mb-2">
        <h1 className="h4 fw-600 mb-0">Waitlist</h1>
        <Button
          title="Promote"
          size="xs"
          theme="create"
          variant="outline"
          disabled={!anyAttendeesChecked()}
          spinner={loading}
          onClick={handleWaitlistPromotion}
        />
      </div>
      <StackView gap={2}>
        {attendees.map(attendee => (
          <AttendeeCheckbox
            key={attendee.id}
            attendee={attendee}
            checked={!!selectedAttendees[attendee.id]}
            onSelect={handleSelect(attendee.id)}
            event={event}
          />
        ))}
      </StackView>
    </>
  )
}

WaitlistedAttendees.propTypes = {
  attendees: arrayOf(
    shape({
      id: number
    })
  ),
  registration: shape({
    id: number
  }),
  event: object
}

export default WaitlistedAttendees
